import { Routes } from '@angular/router';

import { Login } from './pages/login/login';

import { Start } from './pages/start/start';

import { Dashboard } from './pages/dashboard/dashboard';
import { Predictions } from './pages/predictions/predictions';
import { Trading } from './pages/trading/trading';
import { Orders } from './pages/orders/orders';
import { Portfolio } from './pages/portfolio/portfolio';
import { Risk } from './pages/risk/risk';
import { Backtest } from './pages/backtest/backtest';
import { Visuals } from './pages/visuals/visuals';
import { Marketdata } from './pages/marketdata/marketdata';

import { authGuard } from './state/guards/auth.guard';
import { notExpiredGuard } from './state/guards/not-expired.guard';
import { featureGuard } from './state/guards/feature.guard';

export const routes: Routes = [
  { path: 'login', component: Login },

  {
    path: '',
    component: Start,
    canActivate: [authGuard, notExpiredGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },

      {
        path: 'dashboard',
        component: Dashboard,
        canActivate: [featureGuard],
        data: { featureKey: 'pages.dashboard' },
      },
      {
        path: 'predictions',
        component: Predictions,
        canActivate: [featureGuard],
        data: { featureKey: 'pages.predictions' },
      },
      {
        path: 'trading',
        component: Trading,
        canActivate: [featureGuard],
        data: { featureKey: 'pages.trading' },
      },
      {
        path: 'orders',
        component: Orders,
        canActivate: [featureGuard],
        data: { featureKey: 'pages.orders' },
      },
      {
        path: 'portfolio',
        component: Portfolio,
        canActivate: [featureGuard],
        data: { featureKey: 'pages.portfolio' },
      },
      {
        path: 'risk',
        component: Risk,
        canActivate: [featureGuard],
        data: { featureKey: 'pages.risk' },
      },
      {
        path: 'backtest',
        component: Backtest,
        canActivate: [featureGuard],
        data: { featureKey: 'pages.backtest' },
      },
      {
        path: 'visuals',
        component: Visuals,
        canActivate: [featureGuard],
        data: { featureKey: 'pages.visuals' },
      },
      {
        path: 'marketdata',
        component: Marketdata,
        canActivate: [featureGuard],
        data: { featureKey: 'pages.marketdata' },
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./pages/subpages/profile/profile').then((m) => m.Profile),
      }
    ],
  },

  { path: '**', redirectTo: '' },
];
